import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import cx from 'classnames';

import s from './OrganicNavigation.module.css';

type NavItemProps = {
  to: string;

  className?: string;
  children: React.ReactNode;
  newTab?: boolean;
  onClick?: () => void;
};

export const OrganicNavItem = ({
  children,
  to,
  className,
  newTab,
  onClick,
}: NavItemProps) => {
  const { route } = useRouter();

  const isCurrent = route === to;

  return (
    <li className={cx(s.navItem, { [s.navItemCurrent]: isCurrent }, className)}>
      {newTab ? (
        <a href={to} target="_blank" rel="noreferrer" onClick={onClick}>
          {children}
        </a>
      ) : (
        <Link href={to} onClick={onClick}>
          {children}
          {isCurrent ? (
            <span className={s.navItemCurrentA11yHidden}>
              {' -  Current location'}
            </span>
          ) : null}
        </Link>
      )}
    </li>
  );
};
